import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import Auth from './modules/Auth';
import Flash from './modules/Flash';
import Widget from './modules/Widget';
import MySubscriptions from './modules/MySubscriptions';
import Marketing from './modules/Marketing';

import { insert, catchImport } from '@H/utils';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        Auth,
        Flash,
        Widget,
        MySubscriptions,
        Marketing
    },
    state: {
        $browser: {},
        countries: [],
        errorCodes: [],
        formSubmitting: false,
        currentLang: null,
        bus: new Vue()
    },

    getters: {
        autocompleteSettings(state) {
            return state.$browser.name == 'firefox' ? 'off' : 'nope';
        }
    },
    mutations: {
        setBrowser(state, payload) {
            state.$browser = { ...payload };
        },
        setCountries(state, payload) {
            state.countries = [...state.countries, ...payload];
        },
        setFormSubmitting(state, payload) {
            state.formSubmitting = payload;
        },
        setErrorCodes(state, errorCodes) {
            state.errorCodes = errorCodes;
        },
        setCurrentLang(state, lang) {
            state.currentLang = lang;
        }
    },
    actions: {
        async getCountries(ctx) {
            try {
                let {
                    data: { countries }
                } = await axios.get('/countries');
                return countries;
            } catch (err) {
                console.log(err);
            }
        },
        async getOrganisedCountries(ctx) {
            let countries = await ctx.dispatch('getCountries');
            let orgCountries = [];

            Object.keys(countries).forEach(key => {
                if (
                    countries[key] == 'United Kingdom' ||
                    countries[key] == 'United States'
                ) {
                    if (countries[key] == 'United States') {
                        orgCountries = insert(orgCountries, 1, {
                            code: key,
                            value: countries[key],
                            classes: 'country preferred'
                        });
                    } else {
                        orgCountries.unshift({
                            code: key,
                            value: countries[key],
                            classes: 'country preferred'
                        });
                    }
                    orgCountries.push({
                        code: key,
                        value: countries[key],
                        classes: 'country'
                    });
                } else {
                    orgCountries.push({
                        code: key,
                        value: countries[key],
                        classes: 'country'
                    });
                }
            });

            ctx.commit('setCountries', orgCountries);
        },
        setLanguage(ctx, langCode) {
            // Check it's a valid language code, i.e. must exist in availableLanguages.js
            if (typeof this._vm.$codes[langCode] == 'undefined') return;

            ctx.commit('setCurrentLang', langCode);

            // Gettext vue plugin requires localized iso code: en_GB, fr_FR etc.
            this._vm.$language.current = `${langCode.toLowerCase()}_${
                this._vm.$codes[langCode].code
            }`;
        }
    }
});

import(/* webpackChunkName: "enrolment-bundle" */ './modules/Enrolment').then(
    enrolmentModule => {
        store.registerModule('Enrolment', enrolmentModule.default);
    }
).catch(catchImport);

export default store;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/store.js